import React from 'react';
import CardUser from "../../../CertificateDashboard/CardUser";

export default function Faculty({ classes = [] }) {

  const instructors = classes?.reduce(
    (acc, currClass) => {
      const { CertificateClassInstructors, ...rest } = currClass;

      currClass.CertificateClassInstructors.forEach((instructor) => {
        const existingInstructor = acc.find(
          (inst) => +inst.instructor.UserId === +instructor.UserId,
        );

        if (existingInstructor) {
          existingInstructor.classes.push(rest);
        } else {
          acc.push({
            instructor,
            classes: [rest],
          });
        }
      });

      return acc;
    },
    [],
  )

  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap"}}>
      {(instructors || []).map((item, index) => {
        const { instructor, classes } = item;

        return (
          <CardUser
            instructor={{
              ...instructor,
              classes: classes,
            }}
            key={index}
          />
        );
      })}
    </div>
  )
}